/**
 * Información del grupo de pedidos N2
 * Muestra nombre, progreso y lista de pedidos
 */
import React from 'react';
import { Box, Typography, Chip, Stack } from '@mui/material';
import Utils from '../../../../utils/Utils';
import { BADGE_COLORS, getBadgeStyles } from '../../../../components/ui/badgeColors';

/**
 * Componente de información del grupo.
 * Se renderiza como sección dentro del Card único de la página (sin Card propio).
 * El nombre del grupo no se repite aquí: lo muestra la cabecera de la página.
 * @param {Object} props
 * @param {Object} props.order - Objeto con datos del grupo (progress, totalRegister, totalUnits)
 * @param {Array} props.pedidos - Array de pedidos del grupo con número y cliente
 */
const InfoGrupo = ({ order, pedidos }) => {
    if (!pedidos || pedidos.length === 0) {
        return null;
    }

    return (
        <Box
            sx={{
                p: 2,
                border: '2px solid #cc071e',
                borderRadius: 1
            }}
        >
            {/* Barra de progreso: es el dato principal del panel, así que el porcentaje
                manda visualmente sobre el resto del contenido */}
            <Box sx={{ mb: 2.5 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: 1 }}>
                    <Typography sx={{ fontSize: 13, fontWeight: 600, color: '#6c757d' }}>
                        Progreso
                    </Typography>
                    <Typography sx={{ fontSize: 22, fontWeight: 700, color: '#cc071e', lineHeight: 1 }}>
                        {order.progress || 0}%
                    </Typography>
                </Stack>
                <Box sx={{
                    width: '100%',
                    height: 12,
                    backgroundColor: '#e9ecef',
                    borderRadius: 1,
                    overflow: 'hidden'
                }}>
                    <Box sx={{
                        width: `${order.progress || 0}%`,
                        height: '100%',
                        backgroundColor: '#cc071e',
                        transition: 'width 0.3s ease'
                    }} />
                </Box>
                <Typography sx={{ fontSize: 13, color: '#6c757d', display: 'block', mt: 1 }}>
                    {order.totalRegister || 0} / {order.totalUnits || 0} unidades
                </Typography>
            </Box>

            {/* Lista de pedidos */}
            <Typography variant="body2" sx={{ fontWeight: 600, mb: { xs: 1, sm: 1.5 }, color: '#6c757d', fontSize: { xs: 12, sm: 13 } }}>
                Pedidos en este grupo ({pedidos.length}):
            </Typography>
            {/* Chips a 11px y no a los 9-10 de ListaGruposActivos: allí es una lista densa
                de varios grupos, aquí es el panel principal y debe pesar como el contenido
                de ListOrder, que ronda los 13px */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {pedidos.map(pedido => (
                    <Chip
                        key={pedido.numero}
                        label={`${pedido.numero}${pedido.cliente ? ` - ${Utils.toCapitalize(pedido.cliente)}` : ''}`}
                        size="small"
                        sx={getBadgeStyles(BADGE_COLORS.BLUE, { height: 22, fontSize: 11 })}
                    />
                ))}
            </Box>
        </Box>
    );
};

export default InfoGrupo;
